import React from "react";
import { Link, withRouter } from 'react-router-dom';
import Header from "../../components/Header/index";

class NotFound extends React.Component {

    componentDidMount() {
        document.title = '404 Page Not Found - duskPortal';
    }

    handleBackClicked = (event) => {
        event.preventDefault();
        this.props.history.goBack();
    };

    render() {
        let title, subTitle;
        if(this.props.forbidden != undefined) {
            title = "Forbidden";
            subTitle = "You don't have access to this page."
        } else {
            title = "404 Page Not Found";
            subTitle = "Sorry, no page with this URL exists. "
        }
        return <div>
            <Header />
            <main className="content" role="main">
                <div className="vertab">
                    <div className="vertab--inner viewport--width">
            
                        <div className="container padding--100 text--center text--15">
                        
                            <img src="/img/icon-alert--orange.svg" alt="" width="76" height="76" className="icon margin--20--bot" />
                            <h2 className="text--light text--color text--60 margin--20--bot">{title}</h2>
                            <p>
                                {subTitle}
                                <Link to='/' onClick={this.handleBackClicked}> Click here to go back.</Link>
                            </p>
        
                            
                        </div>
                    
                    </div>
                </div>
                
            </main>
        </div>;
    }
}

export default withRouter(NotFound);
